var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmallLogoVerima(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 36,
    viewBox: "0 0 45 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3796 3.4337C44.3796 1.53692 42.8612 0 40.9874 0H17.5681C7.86567 0 0 7.96198 0 17.7833C0 27.6045 7.86567 35.5665 17.5681 35.5665C24.4043 35.5665 30.3221 31.608 33.2254 25.8427L43.9648 5.09057C44.2314 4.59576 44.3796 4.03347 44.3796 3.4337Z",
    fill: "#80E8CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5829 19.4252L21.6417 10.571H28.426L19.5086 27.837H15.6498L6.71021 10.571H13.4945L17.5829 19.4252Z",
    fill: "#0F6E8C"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLogoVerima);
export default __webpack_public_path__ + "static/media/small_logo_verima.556dcfc205bd8ce109e3830dfc7467c1.svg";
export { ForwardRef as ReactComponent };